import React, { Fragment, useContext } from 'react';
import useSectionStyles from './styles';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';

function Info({ sectionData }) {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);
  const theme = useTheme();

  const slidesToShow = isMobile ? 1 : 4;
  const [nodeData] = sectionData.components;
  const carouselList = nodeData?.contentList?.components;
  const cardsCount = carouselList?.length;
  const classes = useSectionStyles({
    cardsCount,
    containerWidth,
    slidesToShow,
    isMobile
  });
  const settings = {
    className: classes.sliderContainer,
    slidesToShow,
    centerMode: true,
    centerPadding: isMobile ? '40px 0 0' : '0px 0 0'
  };

  const carouselContent = carouselList.map((dt, ind) => (
    // Need to keep this Fragment otherwise Slick mutates the top level div
    <Fragment key={ind}>
      <div className={classes.card}>
        <div className={classes.cardContent}>
          <div ref={dt?.icon?.refSetter} className={classes.imageContainer}>
            <Icon
              name={dt.icon.metadata.value}
              color={theme?.colors?.icon}
              width={isMobile ? '30px' : '40px'}
              height={isMobile ? '30px' : '40px'}
            />
          </div>
          <h3
            ref={dt?.contentHeading?.refSetter}
            className={classes.cardHeading}
            dangerouslySetInnerHTML={{
              __html: dt.contentHeading.metadata.value
            }}
          />
          <p
            ref={dt?.contentPara?.refSetter}
            className={classes.cardPara}
            dangerouslySetInnerHTML={{
              __html: dt.contentPara.metadata.value
            }}
          />
        </div>
      </div>
    </Fragment>
  ));

  return (
    <section className={classes.section}>
      <div className={classes.sectionContainer}>
        <div className={classes.partialBackground} />
        <div className={classes.content}>
          <div className={classes.subTitleHeading}>
            <span
              ref={nodeData?.cardHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.cardHeading?.metadata?.value
              }}
            />
          </div>
          <h2 className={classes.heading}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.title?.metadata?.value
              }}
            />
          </h2>

          {cardsCount > slidesToShow ? (
            <Carousel
              hideArrow={isMobile}
              settings={settings}
              // buttonContainerClass={classes.buttonContainerClass}
            >
              {carouselContent}
            </Carousel>
          ) : (
            <div className={classes.contentRow}>{carouselContent}</div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Info;
